import { NetworkTest } from './webRtcTests/NetworkTest'
import { TestMethods } from './webRtcTests/TestMethods'
import { ConnectionTest } from './webRtcTests/ConnectionTest'
import { DataChannelThroughputTest } from './webRtcTests/BandwidthTest'
import { VideoTest } from './webRtcTests/VideoTest'
import { Test, testStates } from './webRtcTests/Test'

const translations = JSON.parse(localStorage.getItem('translations') as string).translations;
export class WebRtcTestHandler {

  private readonly configuration: RTCConfiguration
  private readonly videoButtonStartText = translations.VIDEO_BUTTON_START_TEXT ?? 'Video erneut starten'
  private readonly videoButtonStopText = translations.VIDEO_BUTTON_STOP_TEXT ?? 'Video beenden'
  private readonly testButtonStopText = translations.TEST_BUTTON_STOP_TEXT ?? 'Test abbrechen'
  private readonly testButtonRestartText = translations.TEST_BUTTON_RESTART_TEXT ?? 'Test erneut starten'
  private readonly successIcon = 'done'
  private readonly failureIcon = 'error'
  private readonly warningIcon = 'warning'
  private readonly successText = translations.SUCCESS_TEXT ?? 'Alle Tests erfolgreich. Die Videosprechstunde sollte ohne Probleme funktionieren.'
  private readonly failureText = translations.FAILURE_TEXT ?? 'Ein wichtiger Test ist fehlgeschlagen. Die Videosprechstunde wird vorraussichtlich nicht funktionieren. Bitte kontaktieren Sie unseren Support.'
  private readonly warningText = translations.WARNING_TEXT ?? 'Alle kritischen Tests waren erfolgreich. Die Videosprechstunde sollte funktionieren. Falls es doch zu Problemen kommt, wenden Sie sich an unseren Support.'

  private tests: Test[]

  private videoTestRunning: boolean
  private testsRunning: boolean

  private startButton: HTMLButtonElement
  private startButtonLabel: HTMLSpanElement
  private videoButton: HTMLButtonElement
  private videoButtonLabel: HTMLSpanElement
  private videoError: HTMLDivElement
  private innerVideoTest: HTMLDivElement
  private innerRtcTest: HTMLDivElement
  private finalResultIcon: HTMLSpanElement
  private finalResultText: HTMLLIElement
  private videoResultText: HTMLLIElement
  private allowCameraNotice: HTMLDivElement

  private videoTest: VideoTest | undefined

  public static readonly errorMessages = {
    TIMEOUT: translations.TIMEOUT_MSG ?? 'Der Timeout wurde überschritten',
    PEER_CONNECTION_NOT_FOUND: translations.PEER_CONNECTION_NOT_FOUND_MSG ?? 'Keine Peer Connection gefunden.',
    COULD_NOT_CREATE_OFFER: translations.COULD_NOT_CREATE_OFFER_MSG ?? 'Die Peer Connection konnte keine Anfrage erstellen.',
    COULD_NOT_CREATE_ANSWER: translations.COULD_NOT_CREATE_ANSWER_MSG ?? 'Die Peer Connection konnte keine Antwort erstellen.',
    COULD_NOT_SET_OFFER_DESCRIPTION: translations.COULD_NOT_SET_OFFER_DESCRIPTION_MSG ?? 'Die Anfrage konnte nicht als Beschreibung gesetzt werden.',
    COULD_NOT_SET_ANSWER_DESCRIPTION: translations.COULD_NOT_SET_ANSWER_DESCRIPTION_MSG ?? 'Die Antwort konnte nicht als Beschreibung gesetzt werden.',
    COULD_NOT_FIND_MATCHING_CANDIDATE: translations.COULD_NOT_FIND_MATCHING_CANDIDATE_MSG ?? 'Es wurde kein passender ICE Kandidat gefunden.',
    CANDIDATE_GATHERING_ERROR: translations.CANDIDATE_GATHERING_ERROR_MSG ?? 'Fehler beim Suchen von ICE Kandidaten.',
    COULD_NOT_CREATE_PEER_CONNECTION: translations.COULD_NOT_CREATE_PEER_CONNECTION_MSG ?? 'Peer Connection konnte nicht erstellt werden.',
    COULD_NOT_CREATE_DATA_CHANNEL: translations.COULD_NOT_CREATE_DATA_CHANNEL_MSG ?? 'Es konnte kein Datenkanal erstellt werden.',
    USER_CANCELED: translations.USER_CANCELED_MSG ?? 'Der Test wurde abgebrochen.'
  }

  constructor() {
    this.videoTestRunning = false
    this.testsRunning = false
    this.configuration = { 'iceServers': [JSON.parse('{"urls": "turns:turn1.medcast.cloud:443", "username": "WebAppUser", "credential": "OjhjU2LdLZKgtR"}')],'iceCandidatePoolSize':2 }

    this.startButton = document.getElementById('test-button') as HTMLButtonElement
    this.startButtonLabel = document.getElementById('test-button-label') as HTMLSpanElement
    this.videoButton = document.getElementById('video-button') as HTMLButtonElement
    this.videoButtonLabel = document.getElementById('video-button-label') as HTMLSpanElement
    this.videoError = document.getElementById('video-test-error') as HTMLDivElement
    this.innerVideoTest = document.getElementById('inner-video-test') as HTMLDivElement
    this.innerRtcTest = document.getElementById('inner-rtc-test') as HTMLDivElement
    this.finalResultText = document.getElementById('final-result-text') as HTMLLIElement
    this.finalResultIcon = document.getElementById('final-result-icon') as HTMLSpanElement
    this.videoResultText = document.getElementById('video-result-text') as HTMLLIElement
    this.allowCameraNotice = document.getElementById('allow-camera-notice') as HTMLDivElement

    this.startButton.onclick = () => {
      this.onTestButtonClick()
    }

    this.videoButton.onclick = () => {
      this.onVideoButtonClick()
    }

    let theirVideoElement = document.getElementById('testVideo')
    if (!theirVideoElement) {
      console.error('Video Elements not found!')
    } else {
      this.videoTest = new VideoTest(this.configuration, TestMethods.isRelay, this, theirVideoElement as HTMLVideoElement)
    }
    this.tests = []
  }

  private createNewTests() {
    // network tests
    this.tests.push(new NetworkTest(this.configuration, TestMethods.isTcp, this, document.getElementById('tcp-result') as HTMLLIElement, false))
    this.tests.push(new NetworkTest(this.configuration, TestMethods.isUdp, this, document.getElementById('udp-result') as HTMLLIElement, true))
    this.tests.push(new NetworkTest(this.configuration, TestMethods.isIpv6, this, document.getElementById('ipv6-result') as HTMLLIElement, false))

    // Connectiontests
    this.tests.push(new ConnectionTest(this.configuration, TestMethods.isHost, this, document.getElementById('direct-result') as HTMLLIElement, false))
    this.tests.push(new ConnectionTest(this.configuration, TestMethods.isRelay, this, document.getElementById('relay-result') as HTMLLIElement, true))
    this.tests.push(new ConnectionTest(this.configuration, TestMethods.isReflexive, this, document.getElementById('reflexive-result') as HTMLLIElement, false))

    // Datachannel bandwidth test
    this.tests.push(new DataChannelThroughputTest(this.configuration, TestMethods.isRelay, this, document.getElementById('bandwidth-result') as HTMLLIElement, true))
  }
  
  private onTestButtonClick(){
    this.innerRtcTest.style.setProperty('display', 'block')
    if (!this.testsRunning) {
      this.clearResults()
      this.testsRunning = true
      this.startTests()
      this.startButtonLabel.textContent = this.testButtonStopText
    } else {
      this.tests.forEach(test =>{
        if (test.testState === testStates['running'])  test.endTest(false, WebRtcTestHandler.errorMessages.USER_CANCELED)
      })
      this.startButtonLabel.textContent = this.testButtonRestartText
    }
  }

  public showMediaRequestMessage()
  {
    this.allowCameraNotice.style.setProperty('display', 'block')
  }

  public hideMediaRequestMessage()
  {
    this.allowCameraNotice.style.setProperty('display', 'none')
  }

  public async onVideoButtonClick() {
    this.hideMediaRequestMessage()
    this.innerVideoTest.style.setProperty('display', 'block')
    this.videoError.style.setProperty('display', 'none')
    if (!this.videoTest) {
      this.displayVideoError(translations.INTERNAL_ERROR_PLEASE_RELOAD ?? 'Interner Fehler. Bitte laden Sie die Seite neu und versuchen Sie es nocheinmal. Falls diese Fehlermeldung weiterhin angezeigt wird, kontaktieren Sie bitte unseren Kundensupport.')
      return
    }
    if (this.videoTestRunning) {
      this.videoTestRunning = false
      this.videoButtonLabel.textContent = this.videoButtonStartText
      this.videoTest.endTest(false)
    } else {
      this.videoTestRunning = true
      window.alert(translations.VIDEO_TEST_INFO_MSG ?? 'Da der Video Test auch die Audioverbidung testet, kann es zu Rückkopplungen kommen. Bitte stellen Sie die Lautstärke Ihres Gerätes niedrig oder verwenden Sie Kopfhörer.')
      this.videoError.style.setProperty('display', 'none')
      this.videoButtonLabel.textContent = this.videoButtonStopText
      this.videoTest.startTest()
    }
  }

  public startTests() {
    this.tests.forEach(test =>{
      if(test.testState === testStates['running'])  test.endTest(false, 'User Canceled')
    })
    this.tests = []

    this.createNewTests()
    this.tests.forEach(test => {
      this.getLoaderElement(test.resultElement).style.setProperty('display', 'block')
    })
    this.tests.forEach(test => test.startTest())
  }

  public displayResult(successful: boolean, test: Test, message?: string) {
    let loader = this.getLoaderElement(test.resultElement)
    loader.style.setProperty('display', 'none')

    let resultIconType = successful ? this.successIcon : this.failureIcon
    let resultIconColor = successful ? 'var(--success)' : 'var(--failure)'
    let resultIcon = this.getIconElement(test.resultElement)
    resultIcon.textContent = resultIconType
    resultIcon.style.setProperty('color', resultIconColor)

    let lastTest = true
    this.tests.forEach(test => {
      if (test.testState === testStates['running']) lastTest = false
    })

    if(lastTest){
      this.startButtonLabel.textContent = this.testButtonRestartText
      this.testsRunning = false
      this.displayFinalResult()
    }
  }

  public displayVideoError(errorMessage: string){
    this.onVideoButtonClick()
    this.innerVideoTest.style.setProperty('display', 'none')
    this.videoError.style.setProperty('display', 'block')
    this.videoResultText.textContent = errorMessage
  }

  private getIconElement(resultElement: HTMLElement) : HTMLElement{
    let resultIcon = resultElement.querySelector('.material-icons') as HTMLElement
    if(!resultIcon)
    {
      throw Error('Could not find HTML ELEMENT')
    }
    return resultIcon
  }

  private getLoaderElement(resultElement: HTMLElement) : HTMLElement{
    let loader = resultElement.querySelector('.loader') as HTMLElement
    if(!loader)
    {
      throw Error('Could not find HTML ELEMENT')
    }
    return loader
  }

  private clearResults(){
    this.tests.forEach(test => {
      this.getIconElement(test.resultElement).textContent = ''
    })
    this.finalResultIcon.textContent = ''
    this.finalResultText.textContent = ''
  }

  private displayFinalResult() {
    let criticalTestFailed = false
    let optionalTestFailed = false

    this.tests.forEach(test => {
      if(test.testState === testStates.failed) test.isCritical ? criticalTestFailed = true : optionalTestFailed = true
    })

    if(criticalTestFailed){
      this.finalResultText.textContent = this.failureText
      this.finalResultIcon.textContent = this.failureIcon
      this.finalResultIcon.style.setProperty('color', 'var(--failure)')
    }
    else if(optionalTestFailed){
      this.finalResultText.textContent = this.warningText
      this.finalResultIcon.textContent = this.warningIcon
      this.finalResultIcon.style.setProperty('color', 'var(--warning)')
    }
    else {
      this.finalResultText.textContent = this.successText
      this.finalResultIcon.textContent = this.successIcon
      this.finalResultIcon.style.setProperty('color', 'var(--success)')
    }
  }

}

const handler = new WebRtcTestHandler()